import * as alwaysInCacheTableIdList from './alwaysInCacheTableIdList';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { getFolderChangeDigestAction } from 'owa-mail-focused-inbox-rollup-store';
import { isAllDefaultForFocusedInbox, isFocusedInboxEnabled, } from 'owa-mail-list-actions/lib/utils/FocusedInboxUtil';
import { getInboxTableView } from 'owa-mail-table-loading-actions';
export default function updateAlwaysInCacheTableIds() {
    var isFocusedOtherEnabled = isFocusedInboxEnabled();
    var regularInboxTableView = getInboxTableView(-1 /* None */);
    var focusedInboxTableView = getInboxTableView(0 /* Focused */);
    var otherInboxTableView = getInboxTableView(1 /* Other */);
    // If server side override is ON, which means client will always show Inbox as the default pivot
    if (isAllDefaultForFocusedInbox()) {
        // Add Inbox table to the alwaysInCache list
        alwaysInCacheTableIdList.add(regularInboxTableView);
        if (isFocusedOtherEnabled) {
            if (isMailFeatureEnabled('tri-inbox-focused-pivot')) {
                // Client shows Inbox | Focused pivots, make sure Focused table is added, and Other table is removed
                alwaysInCacheTableIdList.add(focusedInboxTableView);
                alwaysInCacheTableIdList.remove(otherInboxTableView);
            }
            else {
                // Client shows Inbox | Focused | Other pivots, make sure Focused and Other tables are added
                alwaysInCacheTableIdList.add(focusedInboxTableView);
                alwaysInCacheTableIdList.add(otherInboxTableView);
            }
        }
        else {
            // This could happen when user turns off the F/O in settings, in which case we remove the Focused and Other table from
            // alwaysInCache list because client does not show them anymore
            alwaysInCacheTableIdList.remove(focusedInboxTableView);
            alwaysInCacheTableIdList.remove(otherInboxTableView);
        }
    }
    else {
        // If Focused / Other is enabled and Focused table view is not in the always in cache table, add it and Other
        // Else if Focused / Other is NOT enabled and the regular inbox table view is not in the always in cache table, add it
        if (isFocusedOtherEnabled) {
            alwaysInCacheTableIdList.remove(regularInboxTableView);
            alwaysInCacheTableIdList.add(focusedInboxTableView);
            alwaysInCacheTableIdList.add(otherInboxTableView);
            // VSO 13075: Read focused/other rollup data from session data response on boot
            // Making this additional request to get folder change digest for now
            getFolderChangeDigestAction(otherInboxTableView);
        }
        else {
            alwaysInCacheTableIdList.remove(focusedInboxTableView);
            alwaysInCacheTableIdList.remove(otherInboxTableView);
            alwaysInCacheTableIdList.add(regularInboxTableView);
        }
    }
    return 0;
}
//# sourceMappingURL=updateAlwaysInCacheTableIds.js.map